import produce, { Draft } from "immer";

import { SnackbarAction, ACTIONS } from "actions/snackbar";
import { Snackbar } from "types/snackbar";

export interface SnackbarState {
    snackbars: Snackbar[];
}

export const initialState: SnackbarState = {
    snackbars: [],
};

const snackbar = produce((state: Draft<SnackbarState>, action: SnackbarAction) => {
    switch (action.type) {
        case ACTIONS.ADD_SNACKBAR: {
            const { message } = action.payload;
            // prevent duplicate
            const found = state.snackbars.find(
                selectedSnackbar => selectedSnackbar.message === message,
            );
            if (!found) {
                state.snackbars.unshift(action.payload);
            }
            break;
        }
        case ACTIONS.REMOVE_SNACKBAR: {
            const { id } = action.payload;
            state.snackbars = state.snackbars.filter(
                selectedSnackbar => selectedSnackbar.id !== id,
            );
            break;
        }
    }
}, initialState);

export default snackbar;
